import React from 'react';
import { Paragraph, Block } from '@uncinc/react-drupal-core';
import Immutable from 'immutable';
import {
  Container,
} from '../../../components';

const CTAWrapper = ({ entity }) => {
  const id = entity.getIn(['field_cta', 0, 'target_id']);
  const newCtaBlock = entity.getIn(['field_cta_block', 0, 'entity']);
  const paragraphKey = `paragraph:${id}`;


  // We keep the old component for the OF and KP domains, until migrated.
  // https://uncinc.monday.com/boards/420919839/pulses/8926347948.
  if (newCtaBlock !== undefined) {
    return (
      <div className="Paragraph">
        <Block newBlock entity={Immutable.fromJS(newCtaBlock)} />
      </div>
    );
  }

  if (!id) {
    return null;
  }

  return (
    <Container className="Paragraph">
      <div key={paragraphKey} id={paragraphKey}>
        <Paragraph
          id={id}
          entity={entity.getIn(['field_cta', 0, 'entity'])}
          display={entity.getIn(['field_display', 0, 'value'])}
        />
      </div>
    </Container>
  );
};

export default CTAWrapper;

